import React, { useState } from 'react';
import Card from '../../common/card/Card';
import Button from '../../common/button/Button';
import { Modal } from 'antd';
import MovingForms from '../../common/modal/Modal';
import movingIcon from '../../assets/movingIcon.png';
import sendIcon from '../../assets/sendIcon.png';
import movingImg from '../../assets/moving.bmp';

const Moving = (props) => {
  const { ...rest } = props;
  const [showMovingModal, setShowMovingModal] = useState(false);
  const [requestSubmitted, setRequestSubmitted] = useState(false);

  return (
    <Card
      className="w-full lg:w-1/3 "
      title="Buying/Selling a Property?"
      padded={false}
      {...rest}
      serviceRequestColor={props.serviceRequestColor}
    >
      {requestSubmitted ? (
        <div
          className="flex flex-col h-full justify-center"
          onClick={() => setRequestSubmitted(false)}
        >
          <img
            className="w-7 h-6 mx-auto mb-5"
            src={sendIcon}
            alt="send-icon"
          />
          <h3 className="font-bold mx-auto mb-8 text-center">
            MOVING REQUEST SENT!
          </h3>
          <p className="font-bold mx-auto text-center">
            You will receive notification directly from customer service once
            it's been reviewed.
          </p>
        </div>
      ) : (
        <div className="flex flex-col items-stretch w-full h-full">
          <img
            src={movingImg}
            alt="Couple moving"
            className="w-full"
            style={{
              objectFit: 'cover',
              objectPosition: 'center',
              height: '250px',
            }}
          />

          <div className="p-8">
            <Button
              className="w-full"
              iconUrl={movingIcon}
              onClick={() => setShowMovingModal(true)}
            >
              Fill Out Request Form
            </Button>
          </div>
        </div>
      )}
      <Modal
        open={showMovingModal}
        closable={false}
        footer={null}
        width="70vw"
        onCancel={() => setShowMovingModal(false)}
      >
        <MovingForms
          closeHandler={() => setShowMovingModal(false)}
          requestSubmitted={setRequestSubmitted}
        />
      </Modal>
    </Card>
  );
};

export default Moving;
